import ImageCropperContainer from "../../components/bonusUi/imageCropper";

const ImageCropper = () => {
  return <ImageCropperContainer />;
};

export default ImageCropper;
